import React from "react";
import UsedCarsWorkspace from "../components/UsedCarsWorkspace";

export default function UsedCarsInspectionPage() {
  return <UsedCarsWorkspace stage="inspection" />;
}
